/**
 * @purpose: Host Code Setting modal controller - CRUD operations for DIST_TbMDHost
 * @called_by: modal.city.setting.ctrl.js via modalFactory.open()
 * @deps: AngularJS app, urlServices, toaster, $uibModalInstance, params
 * @public: modalHostSettingCtrl
 * @side_effects: loads hosts, saves/deletes hosts, loads provinces
 */
app.controller('modalHostSettingCtrl', ['$scope', '$uibModalInstance', 'urlServices', 'toaster', 'params',
    function($scope, $uibModalInstance, urlServices, toaster, params) {

    // Data models
    $scope.hosts = [];
    $scope.provinces = [];
    $scope.selectedHost = null;
    $scope.isEdit = false;
    $scope.isSaving = false;
    $scope.isLoading = false;
    $scope.filterText = '';

    // Form data
    $scope.formData = {
        HostCode: '',
        HostName: '',
        Company: '',
        Address: '',
        Phone: '',
        Fax: '',
        Mobile: '',
        Email: '',
        Contact: '',
        Province: '',
        IsFullBranch: false
    };

    /**
     * Load all hosts from API
     * Matches VB6 Binding(): SELECT HostCode, HostName, IsFullBranch FROM DIST_TbMDHost ORDER BY HostName
     */
    $scope.loadHosts = function() {
        $scope.isLoading = true;
        urlServices.ambilData('api/customer-price/hosts', {}, function(err, result) {
            $scope.isLoading = false;
            if (err) {
                toaster.pop('error', 'Error', 'Failed to load hosts');
                return;
            }
            $scope.hosts = (result && result.dt) ? result.dt : [];
        });
    };

    /**
     * Load provinces for dropdown
     * Matches VB6 Province(): SELECT ProvinceName FROM DIST_TbMDProvince ORDER BY ProvinceName
     */
    $scope.loadProvinces = function() {
        urlServices.ambilData('api/customer-price/provinces', {}, function(err, result) {
            if (err) {
                toaster.pop('error', 'Error', 'Failed to load provinces');
                return;
            }
            $scope.provinces = (result && result.dt) ? result.dt : [];
        });
    };

    /**
     * Select host from grid for editing
     * Matches VB6 GRID_Click
     */
    $scope.selectHost = function(host) {
        $scope.selectedHost = host;
        $scope.isEdit = true;
        $scope.formData = {
            HostCode: host.HostCode || '',
            HostName: host.HostName || '',
            Company: host.Company || '',
            Address: host.Address || '',
            Phone: host.Phone || '',
            Fax: host.Fax || '',
            Mobile: host.Mobile || '',
            Email: host.Email || '',
            Contact: host.Contact || '',
            Province: host.Province || '',
            IsFullBranch: host.IsFullBranch === true || host.IsFullBranch === 1
        };
    };

    /**
     * Clear form for new entry
     * Matches VB6 Clear()
     */
    $scope.clearForm = function() {
        $scope.selectedHost = null;
        $scope.isEdit = false;
        $scope.formData = {
            HostCode: '',
            HostName: '',
            Company: '',
            Address: '',
            Phone: '',
            Fax: '',
            Mobile: '',
            Email: '',
            Contact: '',
            Province: '',
            IsFullBranch: false
        };
    };

    /**
     * Save host (insert or update)
     * Matches VB6 CmdSimpan_Click with SP_DIST_TbMDHost_Insert
     * Validation: HostCode, HostName, Contact, Email required
     */
    $scope.saveHost = function() {
        // Validation matching E.md
        if (!$scope.formData.HostCode) {
            toaster.pop('warning', 'Validation', 'Host Code cannot be empty');
            return;
        }
        if (!$scope.formData.HostName) {
            toaster.pop('warning', 'Validation', 'Host Name cannot be empty');
            return;
        }
        if (!$scope.formData.Contact) {
            toaster.pop('warning', 'Validation', 'Contact cannot be empty');
            return;
        }
        if (!$scope.formData.Email) {
            toaster.pop('warning', 'Validation', 'Email cannot be empty');
            return;
        }

        $scope.isSaving = true;
        urlServices.simpanData('api/customer-price/host', $scope.formData, function(err, result) {
            $scope.isSaving = false;
            if (err) {
                toaster.pop('error', 'Error', err.err || 'Failed to save host');
                return;
            }
            toaster.pop('success', 'Success', result.message || 'Host saved successfully');
            $scope.clearForm();
            $scope.loadHosts();
        });
    };

    /**
     * Delete selected host
     * Matches VB6 CmdHapus_Click
     */
    $scope.deleteHost = function() {
        if (!$scope.selectedHost) {
            toaster.pop('warning', 'Warning', 'Please select a host to delete');
            return;
        }

        if (!confirm('Are you sure you want to delete this host code?')) {
            return;
        }

        $scope.isSaving = true;
        urlServices.hapusData('api/customer-price/host', { HostCode: $scope.selectedHost.HostCode }, function(err, result) {
            $scope.isSaving = false;
            if (err) {
                toaster.pop('error', 'Error', err.err || 'Failed to delete host');
                return;
            }
            toaster.pop('success', 'Success', result.message || 'Host deleted successfully');
            $scope.clearForm();
            $scope.loadHosts();
        });
    };

    /**
     * Filter hosts by search text
     * Matches VB6 txtCode_KeyPress search
     */
    $scope.getFilteredHosts = function() {
        if (!$scope.filterText) {
            return $scope.hosts;
        }
        var filter = $scope.filterText.toLowerCase();
        return $scope.hosts.filter(function(host) {
            return (host.HostCode && host.HostCode.toLowerCase().indexOf(filter) !== -1) ||
                   (host.HostName && host.HostName.toLowerCase().indexOf(filter) !== -1);
        });
    };

    /**
     * Close modal
     */
    $scope.close = function() {
        $uibModalInstance.dismiss('cancel');
    };

    // Initialize
    $scope.loadHosts();
    $scope.loadProvinces();
}]);
